export default {
  label: 'Button',
  action: 'submit',
  showValidations: false,
  leftIcon: '', // css classes eg: "fa fa-plus"
  rightIcon: '',
  size: '', // lg, sm, block
  theme: 'primary', // all supported by bootstrap 4
  description: '',
  block: false,
  customClass: '',
  key: 'button',
  type: 'buttonComponent',
  input: true,
  customAction: '', // for custom action
  event: '' // for custom events
};
